import { Select, SelectListPosition, SelectType, Textarea } from '@ui/src';
import { InitialCDDBusinessTypes } from '../types';
import BusinessPartners from './business-partners';

import cn from '../styles.module.css';

const InitialCDDBusiness = ({
  businessPartners,
  baseCurrency,
  clientScheme,
  monthlyTurnoverCorporate,
  cddFormValues,
  onChange,
  currencies,
}: InitialCDDBusinessTypes) => (
  <>
    <BusinessPartners
      businessPartners={businessPartners}
      baseCurrency={baseCurrency}
      clientScheme={clientScheme}
      monthlyTurnoverCorporate={monthlyTurnoverCorporate}
    />
    {(clientScheme?.purposeOfAccountActive ||
      clientScheme?.amlCtfComplianceProgramActive ||
      clientScheme?.expectedTypeOfClientsActive ||
      clientScheme?.requiredCurrenciesCryptoActive) && (
      <>
        <div className={cn.businessPartnersTitle}>
          Business & Compliance Profile
        </div>
        {clientScheme?.purposeOfAccountActive && (
          <div className={cn.realMonthlyVolumeWrapper}>
            <div
              className={`${cn.realMonthlyVolume} ${cn.realMonthlyVolumeCorporate}`}
            >
              <div className={cn.realMonthlyVolumeTitle}>
                Purpose of account
              </div>
              <div className={cn.realMonthlyVolumeValue}>
                <Textarea
                  name="purposeOfAccount"
                  value={cddFormValues?.purposeOfAccount}
                  placeholder="Describe Purpose of account"
                  className={`${cn.purposeOfAccount} borderless`}
                  onChange={onChange}
                />
              </div>
            </div>
          </div>
        )}
        {clientScheme?.expectedTypeOfClientsActive && (
          <div className={cn.realMonthlyVolumeWrapper}>
            <div
              className={`${cn.realMonthlyVolume} ${cn.realMonthlyVolumeCorporate}`}
            >
              <div className={cn.realMonthlyVolumeTitle}>
                Expected types of clients
              </div>
              <div className={cn.realMonthlyVolumeValue}>
                <Select
                  name="expectedTypeOfClients"
                  value={cddFormValues?.expectedTypeOfClients}
                  list={[
                    {
                      name: 'B2B',
                      value: 'B2B',
                    },
                    {
                      name: 'B2C',
                      value: 'B2C',
                    },
                  ]}
                  placeholder="Select types"
                  selectWrapperClassName={`${cn.expandableRowContentSelect} ${cn.disabledSelect} ${cn.monthlyVolumeSelector}`}
                  mode={SelectType.MULTIPLE}
                  selectListPosition={SelectListPosition.TOP}
                  onChange={onChange}
                  borderless
                />
              </div>
            </div>
          </div>
        )}
        {clientScheme?.expectedTypeOfClientsActive && (
          <div className={cn.realMonthlyVolumeWrapper}>
            <div
              className={`${cn.realMonthlyVolume} ${cn.realMonthlyVolumeCorporate}`}
            >
              <div className={cn.realMonthlyVolumeTitle}>
                Required currencies
              </div>
              <div className={cn.realMonthlyVolumeValue}>
                <Select
                  name="requiredCurrenciesCryptoId"
                  value={cddFormValues?.requiredCurrenciesCryptoId}
                  list={currencies}
                  placeholder="Select currencies"
                  selectWrapperClassName={`${cn.expandableRowContentSelect} ${cn.disabledSelect} ${cn.monthlyVolumeSelector}`}
                  mode={SelectType.MULTIPLE}
                  selectListPosition={SelectListPosition.TOP}
                  onChange={onChange}
                  borderless
                />
              </div>
            </div>
          </div>
        )}
        {clientScheme?.amlCtfComplianceProgramActive && (
          <div className={cn.realMonthlyVolumeWrapper}>
            <div
              className={`${cn.realMonthlyVolume} ${cn.realMonthlyVolumeCorporate}`}
            >
              <div className={cn.realMonthlyVolumeTitle}>
                Do you have a AML/CTF Compliance Programm
              </div>
              <div className={cn.realMonthlyVolumeValue}>
                <Select
                  name="amlCtfComplianceProgram"
                  value={cddFormValues?.amlCtfComplianceProgram}
                  list={[
                    {
                      name: 'Yes',
                      value: 'yes',
                    },
                    {
                      name: 'No',
                      value: 'no',
                    },
                  ]}
                  placeholder="Select option"
                  selectWrapperClassName={`${cn.expandableRowContentSelect} ${cn.disabledSelect} ${cn.monthlyVolumeSelector} ${cn.fixHeight}`}
                  selectListPosition={SelectListPosition.TOP}
                  onChange={onChange}
                  borderless
                />
              </div>
            </div>
          </div>
        )}
      </>
    )}
  </>
);

export default InitialCDDBusiness;
